import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { SyllabusQuery, SyllabusUIModel } from '@examdojo/category/v2';
import { IconComponent } from '@examdojo/core/icon';
import { CmsUrlParts } from '../cms/cms.model';

@Component({
  selector: 'exam-overview',
  imports: [RouterLink, IconComponent],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverviewComponent {
  constructor(private readonly syllabusQuery: SyllabusQuery) {}

  readonly state = connectState({
    accessibleSyllabuses: this.syllabusQuery.selectAllEntities(),
  });

  getSyllabusRoute(syllabus: SyllabusUIModel): string[] {
    return ['/', CmsUrlParts.Syllabus, syllabus.slug, CmsUrlParts.Sources];
  }
}
